<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Admin</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'admin'}" exact exact-active-class="tab_active">Admin</b-nav-item>
        <b-nav-item :to="{name: 'users'}" exact exact-active-class="tab_active">Users</b-nav-item>
        <b-nav-item :to="{name: 'search'}" exact exact-active-class="tab_active">Search</b-nav-item>
        <b-nav-item :to="{name: 'website_recorder'}" exact exact-active-class="tab_active">Website Recorder</b-nav-item>
        <b-nav-item :to="{name: 'quality_control'}" active-class="tab_active">Quality Control</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user"/>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user']
}
</script>

<style>

</style>
